import { useInventory } from '../../Inventory/Inventory.hooks';
import { Modal } from '@mantine/core';
import { DTIPurchaseStateProvider } from './Purchase.hooks';
import { DTIPurchaseInterior } from './Purchase.Interior';

export function DTIPurchaseModal() {
  const { showPurchaseModal, closePurchaseModal, initialPurchaseEvent } = useInventory('showPurchaseModal', 'closePurchaseModal', 'initialPurchaseEvent');
  if (!showPurchaseModal) return null;
  return (
    <Modal
      opened
      onClose={() => closePurchaseModal()}
      centered
      withCloseButton={false}
      size={1640}
      styles={{
        content: { height: 1000, maxHeight: '90%', width: '100%', maxWidth: 1640, padding: 0, flex: 1 },
        body: { height: 1000, maxHeight: '100%', width: 1640, maxWidth: '100%', padding: 0 },
        inner: { padding: 0, maxHeight: '100%', width: '90%', marginLeft: '5%', marginRight: '5%', background: 'transparent' },
      }}
    >
      <DTIPurchaseStateProvider onClose={closePurchaseModal} initialEvent={initialPurchaseEvent}>
        <DTIPurchaseInterior />
      </DTIPurchaseStateProvider>
    </Modal>
  );
}
